
import { InterceptMiddle } from '../../regular';
/**
 * 判断排序题(QuestionLabel)中指定选项(Number2)排在指定位置(Number1)
 * @param condition 条件str
 * @param list 试题list
 * @return Boolean
 */
export const Order = (list, condition) => {
    // Order[Q1:1:2]
    if (!condition) return false
    let result = false
    try {
        let code = InterceptMiddle(condition.split(':')[0], ['['], ['==', '>', '>=', '<', '<=', '_', ':'])
        let num1 = condition.split(':')[1]
        let num2 = InterceptMiddle(condition.split(':')[2], [':'], [']'])
        list.forEach(info => {
            if (code == info.quesCode && info.bindIsShow && info.isShow && info.questionsTypeId == '14') {
                if(info.optionList[num2 - 1].oid == info.userAnswerArr[num1 - 1]){
                    result = true
                }
            }
        })
        return result;
    } catch (error) {
        console.log('error :>> ', error);
        return false
    }
}